// STEP 5 · 소비자 상품 상세페이지 · detail_blocks 렌더러.
// - text  : whitespace-pre-line 로 안전 렌더 (일반 텍스트 · innerHTML 사용 안 함)
// - image : SafeImg fallback 재사용
// - html  : DOMPurify.sanitize() 로 XSS 차단 후 dangerouslySetInnerHTML.
//   차단 대상: <script>, <iframe>, on*=(onclick 등), javascript:URL, style expressions.
import React from 'react';
import DOMPurify from 'dompurify';
import SafeImg from '@/components/SafeImg';

// DOMPurify 기본값이 이미 안전하지만, 명시적으로 실행 벡터를 전부 차단.
const SANITIZE_CFG = {
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'meta', 'link', 'base'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onmouseenter', 'onmouseleave',
                'onfocus', 'onblur', 'onchange', 'onsubmit', 'onkeydown', 'onkeyup', 'onkeypress',
                'formaction', 'srcdoc'],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
};

export default function ProductDetailRenderer({ blocks = [], legacyDescription = '' }) {
  const list = Array.isArray(blocks) ? blocks.filter(Boolean) : [];

  // 신규 블록이 없으면 legacy description 을 텍스트로 폴백 (하위호환).
  if (list.length === 0) {
    if (!legacyDescription) return null;
    return (
      <p className="text-sm whitespace-pre-line leading-relaxed text-gray-800 dark:text-gray-200"
        data-testid="product-description">{legacyDescription}</p>
    );
  }

  return (
    <div className="space-y-4" data-testid="product-detail-blocks">
      {list.map((b, i) => {
        const key = b.id || `blk-${i}`;
        if (b.type === 'text') {
          return (
            <p key={key} className="text-sm whitespace-pre-line leading-relaxed text-gray-800 dark:text-gray-200"
              data-testid={`pdb-text-${i}`}>{b.text || ''}</p>
          );
        }
        if (b.type === 'image' && b.url) {
          return (
            <SafeImg key={key} src={b.url} kind="broadcast" alt=""
              className="w-full max-w-full h-auto rounded"
              data-testid={`pdb-image-${i}`}/>
          );
        }
        if (b.type === 'html' && b.html) {
          const clean = DOMPurify.sanitize(b.html, SANITIZE_CFG);
          return (
            <div key={key}
              className="text-sm leading-relaxed text-gray-800 dark:text-gray-200 [&_img]:max-w-full [&_img]:h-auto [&_img]:rounded"
              data-testid={`pdb-html-${i}`}
              dangerouslySetInnerHTML={{ __html: clean }}/>
          );
        }
        return null;
      })}
    </div>
  );
}
